import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import People from "../people/People";
import Companies from "../people/Companies";
import Sales from "../sales/Sales";
import States from "../utils/States";
import EmailTemplates from "../utils/EmailTemplates";
import "./OutreachLayout.css";

const OutreachLayout = ({ showToast, currentUser }) => {
  return (
    <div className="outreach-layout">
      <div className="outreach-content">
        <Routes>
          <Route path="/" element={<Navigate to="/outreach/people" replace />} />
          <Route path="/people" element={<People showToast={showToast} currentUser={currentUser} />} />
          <Route path="/companies" element={<Companies showToast={showToast} currentUser={currentUser} />} />
          <Route path="/sales" element={<Sales showToast={showToast} currentUser={currentUser} />} />
          <Route path="/states" element={<States showToast={showToast} currentUser={currentUser} />} />
          <Route path="/email-templates" element={<EmailTemplates showToast={showToast} currentUser={currentUser} />} />
        </Routes>
      </div>
    </div>
  );
};

export default OutreachLayout;

